export const ROUNDING_MULTIPLIER = 1000;
